// Overlay stack for a map: every visible layer in config.layers renders its
// markers on top of the base layer (supplied by MapViz). Grouping per layer
// is delegated to layerItems, and rendering dispatches to the
// per-type functions in mapLayerMarkers.
import React from 'react';
import { layerItems } from './mapLayerModel';
import { renderDots, renderPie, renderBar, renderDonuts, renderLabels } from './mapLayerMarkers';

export default function MapLayers({ points, config }) {
  const layers = (config && config.layers) || [];
  return (
    <>
      {layers
        .filter((layer) => layer.visible)
        .map((layer) => (
          <LayerMarkers key={layer.id} layer={layer} points={points} />
        ))}
    </>
  );
}

function LayerMarkers({ layer, points }) {
  const items = layerItems(points, layer.group);
  switch (layer.type) {
    case 'dots':
      return renderDots(layer, items);
    case 'pie':
      return renderPie(layer, items);
    case 'bar':
      return renderBar(layer, items);
    case 'donuts':
      return renderDonuts(layer, items);
    case 'labels':
      return renderLabels(layer, items);
    default:
      return null;
  }
}
